<template>
        <div class="section1">
            <div class="section bordered">
              <h2>Password Requirements</h2>
              <div class="content" data-section-name="generalinfo">
                  <b-row class="mt-4">
                    <b-col><h3>Passwords must:</h3></b-col>
                  </b-row>
                  <b-row class="mt-4">
                    <b-col lg="6">
                      <ul class="thick ml-2">
                        <li :class="validateErrorClass(tenCharRule)">{{tenCharRule.message}}</li>
                      </ul>
                    </b-col>
                  </b-row>
                  <b-row class="mt-4">
                    <b-col><h3>And have at least 3 out of 4:</h3></b-col>
                  </b-row>
                  <b-col lg="6">
                    <ul class="thick ml-2">
                      <li v-for="rule in rules" :key="rule.message" :class="validateErrorClass(rule)">{{rule.message}}</li>
                    </ul>
                  </b-col>
                  <br />
                  <b-form @submit="onSubmit">
                    <b-row class="mt-4">
                      <b-col lg="6"><FormInput label="Current Password" :value="currentPassword" name="currentPassword" :required=required :showRequired=required @inputUpdated="updateInput" type="password"/></b-col>
                    </b-row>
                    <b-row class="mt-4">
                      <b-col lg="6"><FormInput label="New Password" :value="newPassword" name="newPassword" :required=required :showRequired=required @inputUpdated="updateInput" type="password" :state="isPasswordValid"/></b-col>
                    </b-row>
                    <b-row class="mt-4">
                      <b-col lg="6"><FormInput label="Verify Password" :value="verifyPassword" name="verifyPassword" :required=required :showRequired=required @inputUpdated="updateInput" type="password" :state="samePasswords" /></b-col>
                    </b-row>
                  <b-row class="mt-5">
                      <b-col offset-lg="3" lg="6"><b-button type="submit" block variant="arm-primary" :disabled="!isDisabled">Submit</b-button></b-col>
                  </b-row>
                  </b-form>
              </div>
            </div>
            <b-row class="mt-4">
                <b-col lg="10">
                  <b-alert v-if="response && response!='' && showError && updateFailed" show variant="danger" class="thick">
                    <span v-if="typeof response === 'string' && response.includes('Last request')">
                      Your last request was made within the last 2 hours. Please wait before attempting to update your password again.
                    </span>
                    <span v-else>
                      Sorry! We have encountered an error. The username or password entered does not match with our records.
                      If this problem persists, please use the ARM password help page to request a reset. Thank you.
                    </span>
                  </b-alert>
                    <b-alert :show="showError && !updateFailed" variant="success">
                        <h3>Success!</h3>
                        Your password has been successfully updated with ARM. You may
                        continue to use the ARM Site.
                    </b-alert>
                </b-col>
            </b-row>
        </div>
</template>

<script>
    import FormInput from "@/components/FormInput"
    import _ from "underscore"
    import Config from "../config";
    import axios from "axios";
    import authenticatedAxios from "../authenticated-axios";

    // axios.defaults.withCredentials = false

    export default {
        name: "ResetContent",
        components: {
            FormInput
        },
        data() {
            return {
                isUsernameDisabled: true,
                threeOutOfFourRulePassed: false,
                userame: "",
                currentPassword: "",
                newPassword: "",
                verifyPassword: "",
                required: true,
                showError: false,
                updateFailed: false,
                rules: [
                  {message: "One upper-case character", regex:/[A-Z]+/},
                  {message: "One lower-case character", regex:/[a-z]+/},
                  {message: "One number", regex:/[0-9]+/},
                  {message: "One of the following special characters: '#?!@$%^&*-'", regex:/[#?!@$%^&*-]/},
                ],
              tenCharRule: {message: "Be at least 10 characters long", regex:/.{10,}/},
              response: "",
              submitted: false,
            }
        },
        computed: {
          isPasswordValid() {
            var errors = []
            _.each(this.rules, (rule) => {
              if (!rule.regex.test(this.newPassword))
                errors.push(rule.message)
            })
            this.checkThreeOutOfFourRule(errors)
            if (errors.length > 1) {
              return false
            } else {
              if (this.newPassword.length >= 10) {
                return true
              } else {
                return false
              }
            }

          },
            samePasswords () {
                return this.passwordsFilled() && (this.newPassword == this.verifyPassword) ? true : false
            },
            isDisabled() {
                return this.isPasswordValid && this.samePasswords && !this.submitted ? true : false
            }
        },
        mounted() {
            this.init()
        },
        watch: {
            // subscriptionDetails:  "setDataValues",
            $route: "init"
        },
        methods: {
            checkThreeOutOfFourRule(errors) {
              this.threeOutOfFourRulePassed = errors.length < 2
            },
            init() {
                if (this.$route.params.id) {
                    this.username = this.$route.params.id
                }
            },
            passwordsFilled () {
                return (this.newPassword !== '' && this.verifyPassword !== '')
            },
          validateErrorClass(condition) {
            if (condition.regex.test(this.newPassword)) {
              return "valid"
            } else {
              if (condition.message === "Be at least 10 characters long") {
                return "invalid"
              } else if (this.threeOutOfFourRulePassed) {
                return null
              } else {
                return "invalid"
              }
            }
          },
            updateInput(payload) {
                this[payload.label] = payload.value
            },
            onSubmit(ev) {
                ev.preventDefault()
                if (!this.samePasswords) {
                   this.errorMsg = "The New and Verify Passwords entered doesn't match."
                    return false
                } else {
                    this.submitted = true
                    // var people = {
                    //     username: this.username
                    // }
                    var payload = {
                        username: this.username,
                        currentPassword: this.currentPassword,
                        newPassword: this.newPassword
                    }
                    var self = this
                    authenticatedAxios({
                        method: "put",
                        url: `${Config.api.url}/users/update-password`,
                        // headers: {
                        //     Authorization: `Basic ${btoa(`${this.username}:${this.currentPassword}`)}`
                        // },
                        data: payload
                    }).then((response) => {
                        if (response.status === 200) {
                            self.showError = true
                            self.updateFailed = false
                        }
                        // else {
                        //     self.showError = true
                        //     self.updateFailed = true
                        // }
                    }).catch((error) => {
                        if (error.response.status === 400 || error.response.status === 500) {
                          if (error.response.data && error.response.data.response_message) {
                            self.response = error.response.data.response_message
                          } else if (error.response.data) {
                            const responseString = error.response.data
                            const jsonStringMatch = responseString.match(/:\s*"(.*)"/)
                            if (jsonStringMatch) {
                              const jsonString = jsonStringMatch[1]
                              const responseJson = JSON.parse(jsonString)
                              self.response = responseJson.response_message
                            }
                          }
                          self.showError = true
                          self.updateFailed = true
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>
